import { FileWithPath } from "react-dropzone";

export interface S3SignedRequestByIdResponse {
  upload_id: string;
  urls: string[];
  key: string;
}

export function getRootPath(files: File[]) {
  if (files.length > 0) {
    const pathArray = files[0].name.split("/").filter((v) => !!v);
    if (pathArray.length > 1) {
      return pathArray[0];
    }
  }
  return "";
}

export function renameDuplicateFilesInPlace(files: FileWithPath[]) {
  const fileNames: string[] = [];
  return files.map((file) => {
    let path = file.path || file.name;
    // When we are dropping the folder then there is "/" as a prefix in the path.
    // For eg:
    // Path when selecting the folder: BMW Client/Shots/RT_HS_SH01.001.jpg.
    // Path when dropping the folder: /BMW Client/Shots/RT_HS_SH01.001.jpg.
    if (path.startsWith("/")) {
      path = path.substring(1);
    }
    if (path.startsWith("./")) {
      path = path.substring(2);
    }
    // Generating unique path if a file with the same name exists
    let suffix = 1;
    let newPath = path;
    const pathArray = path.split(".");
    const extension = pathArray.pop();
    const fullPath = pathArray.join(".");
    while (fileNames.includes(newPath)) {
      newPath = `${fullPath}-${suffix}.${extension}`;
      suffix += 1;
    }

    fileNames.push(newPath);
    return new File([file], newPath);
  });
}
